import { Action } from '@ngrx/store';

export enum DownloadActionTypes {
    DOWNLOAD_ACTION = '[Download] Download document action'
}

export class ActionDownload implements Action {
    readonly type = DownloadActionTypes.DOWNLOAD_ACTION;
    constructor() { }
}

export type DownloadActions = ActionDownload;
